import React from "react";
import styles from "./StoriesThumb.module.scss";
import classNames from "classnames/bind";
import { useStoriesProviderData } from "../../../providers/storiesProvider";
import "./StoriesThumb.scss";
import { StoryType } from "@core/types";
import { Image } from "../../Image/Image";
import { SmartImage } from "../../SmartImage/SmartImage";

const cx = classNames.bind(styles);

interface StoriesThumbProps {
  index: number;
  thumbName: StoryType["name"];
  thumbnailURL: StoryType["thumbnailURL"];
}

const StoriesThumb = ({ index, thumbName, thumbnailURL }: StoriesThumbProps) => {
  const { setInitialIndex } = useStoriesProviderData();

  return (
    <div className={cx("thumb-wrapper")} onClick={() => setInitialIndex(index)}>
      <div className={cx("thumb")}>
        <span className={cx("thumb__link")}>
          <div className={cx("image__wrap")}>
            <SmartImage className={cx("image")} src={thumbnailURL} alt={thumbName} lazyLoad />
          </div>
          <div className={cx("thumb__content")}>
            <div className={cx("thumb__title")}>{thumbName}</div>
          </div>
        </span>
      </div>
    </div>
  );
};

export { StoriesThumb };
